import React, { useState } from "react";
import Card from "@/components/Card";
import { Tabs } from "antd";
import TradeLog from "./TradeLog";
import Transaction from "./Transaction";
import RiskReturn from "./RiskReturn";
import DrawDown from "./DrawDown";
import ReturnsBySymbol from "./ReturnsBySymbol";
import RoundTrips from "./RoundTrips";

const { TabPane } = Tabs;

export default () => {

  const dataTableMap: Record<string, JSX.Element> = {
    "Profit/Loss": <RiskReturn/>,
    Transaction: <Transaction />,
    "Trade Log": <TradeLog />,
    "Drawdown Period": <DrawDown />,
    "Returns by Symbol": <ReturnsBySymbol />,
    "Round Trips Details": <RoundTrips />
  };
  const [activeKey, setActiveKey] = useState("Profit/Loss");

  return (
    <Card>
      <Tabs type="card" activeKey={activeKey} onChange={setActiveKey}>
        {Object.keys(dataTableMap).map(e => (
          <TabPane tab={e} key={e}>
            {dataTableMap[e]}
          </TabPane>
        ))}
      </Tabs>
    </Card>
  );
};
